"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * This script implements filter group visibility functions
 */
var waitForElement_1 = require("../../../../../ww_project/Resources/Private/app/helpers/waitForElement");
var constantsClasses_1 = require("../../../../../ww_project/Resources/Private/app/data/constantsClasses");
var CompusoftFilterGroups = /** @class */ (function () {
    function CompusoftFilterGroups() {
        var _this = this;
        this.isRunning = true;
        (0, waitForElement_1.waitForElement)('#ProfileFilterWrapper').then(function (element) {
            _this.initFilterGroups(element);
            // Listen to DOM changes if compusoft decides to randomly update the filter content
            var config = { attributes: true, childList: true, subtree: true };
            var callback = function (mutationList) {
                for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                    var mutation = mutationList_1[_i];
                    if (mutation.type === 'childList') {
                        _this.initFilterGroups(element);
                    }
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(element, config);
            // Close all groups on outside click
            document.addEventListener('click', function () {
                _this.closeAllGroups();
            });
        });
    }
    CompusoftFilterGroups.prototype.initFilterGroups = function (parent) {
        var _this = this;
        if (!this.isRunning)
            return;
        this.filterGroups = parent.querySelectorAll('.profile-filter-group');
        this.filterGroups.forEach(function (group) {
            var selector = group.querySelector('.profile-filter-group-selector');
            selector.onclick = function () { return _this.openGroup(group); };
            // Check filter properties again if compusoft reloads content
            _this.properties = group.querySelectorAll('.profile-filter');
            _this.properties.forEach(function (property) {
                setTimeout(function () {
                    if (property.querySelector('input[type="checkbox"]').checked) {
                        property.classList.add('checked');
                    }
                    else {
                        property.classList.remove('checked');
                    }
                }, 200);
            });
        });
        this.isRunning = false;
        setTimeout(function () {
            _this.isRunning = true;
        }, 1000);
    };
    CompusoftFilterGroups.prototype.openGroup = function (group) {
        this.closeAllGroups(group);
        group.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
    };
    CompusoftFilterGroups.prototype.closeAllGroups = function (elementToIgnore) {
        this.filterGroups.forEach(function (group) {
            if (group.classList.contains(constantsClasses_1.CLASS_ACTIVE) && group != elementToIgnore) {
                group.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                group.querySelector('.profile-filter-group-popup').style.display = 'none';
            }
        });
    };
    return CompusoftFilterGroups;
}());
exports.default = CompusoftFilterGroups;
